import { User } from "./user.model";

export class EmployeeMessageItem {
	pk: string; //EMPMSG_venueKey_employeeRecordNumber
	sk: string; //:createdDateTime.unix
	authorUserKey: string;
	created: string;
	modified: string;
	subject: string;
	body: string;
	notificationType: number;
	notificationAddress: string;
	sentDateTime: string;
	sendDateTime: string;
	readDateTime: string;
	error: string;

	authorUser: User;

	public constructor(init?: Partial<EmployeeMessageItem>) {
		Object.assign(this, init);
	}
}
